<template>
    <div class="app-container">
        <CustomerFlowSearch :listQuery.sync="listQuery" :importSources="importSources" :offlineSources="offlineSources"
            :dealerOptions="dealerOptions" @do-search="doSearch" @do-reset="doReset" @do-export="doExport"
            @show-add-dialog="showAddDialog" @resend-orders="resendOrders"
            @show-assign-dealer-dialog="showAssignDealerDialog" @show-import-dialog="showImportDialog"
            ref="CustomerFlowSearch" />
        <el-table ref="multipleTable" :data="list" v-loading="listLoading" fit border highlight-current-row
            style="width: 100%" max-height="530">
            <template>
                <el-table-column :resizable="false" width="60px" :render-header="renderHeader" align="center">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.itemCheck" @change="toggleCheck(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>

                <el-table-column v-for="column in tableColumns" :key="column.prop" :prop="column.prop"
                    :align="column.align || 'left'" :label="column.label" :width="column.width"
                    :min-width="column.minWidth" :fixed="column.fixed">
                    <template slot-scope="{row}">
                        <slot :name="column.prop" :row="row">
                            <template v-if="column.prop === 'status'">
                                <el-tag :type="statusTagMap.get(row.status)">
                                    {{ statusMap.get(row.status) }}
                                </el-tag>
                            </template>
                            <template v-else-if="column.prop === 'operation'">
                                <el-button size="mini"
                                    v-if="isSuper || roles_all.includes('ONLINE_CLUE_VIEW_DETAIL')"
                                    @click="showSummaryDialog(row)">
                                    详情
                                </el-button>
                                <el-button size="mini"
                                    v-if="isSuper || roles_all.includes('ONLINE_CLUE_VIEW_TRACK')"
                                    @click="showTimelineDialog(row)">
                                    轨迹
                                </el-button>
                            </template>
                            <template v-else>
                                {{ formatterColumnData(row, column) }}
                            </template>
                        </slot>
                    </template>
                </el-table-column>
            </template>
        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 添加数据 -->
        <AddClue :visible.sync="newDialogVisible" :importSources="importSources" :dealerOptions="dealerOptions"
            :seriesOptions="seriesOptions" @getList="getList" @blc="handleBlc"></AddClue>

        <!-- 回收 -->
        <AssignDealer :visible.sync="assignDealerDialog" :dealerOptions="dealerOptions"
            :multipleSelection="multipleSelection" :queryParams="getCommonParams()" :isAllCheck="isAllCheck"
            @clearCheckGetList="clearCheckGetList">
        </AssignDealer>

        <!-- 轨迹 -->
        <Timeline :visible.sync="timelineDialog" :viewData="viewData"></Timeline>

        <!-- 详情 -->
        <Detail :visible.sync="viewDialogVisible" :viewData="viewData"></Detail>

        <!-- 线索导入 -->
        <ImportClue :visible.sync="importDialogVisible" @reset="doReset"></ImportClue>

        <!-- blc拦截弹窗 -->
        <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
    </div>
</template>

<script>
import store from "@/store";
import { remoteMap, statusMap, statusTagMap, clueTypeMap, flowTypeMap, CONSTANT_0, CONSTANT_1, CONSTANT_2 } from './js/form-options'
import CustomerFlowSearch from './components/CustomerFlowSearch.vue'
import BlcTips from "@/components/BlcTips/index";
import AddClue from './components/AddClue.vue'
import AssignDealer from './components/AssignDealer.vue'
import ImportClue from './components/ImportClue.vue'
import Timeline from './components/Timeline.vue'
import Detail from './components/Detail.vue'
import { parseTime } from '@/utils/index'
const initListQuery = {
    page: 1,
    limit: 10,
    isRemote: null,
    status: [99],
    source: [],
    clueId: null, // 线索id
    dealerCode: [],
    province: "",
    city: "",
    name: "",
    specName: "",
    dateType: 1,
    dateRange: [new Date(), new Date()],
    sourceDesc: "",
    ownerName: "",
    salesLevel: [],
    dealerTypes: [],
    level: [],
    clueType: null, // 线索类型
    flowType: null, // 流量类型
}

export default {
    name: "ClueList",
    components: { CustomerFlowSearch, AddClue, AssignDealer, ImportClue, Timeline, Detail, BlcTips },
    data() {
        return {
            parseTime,
            statusTagMap: Object.freeze(statusTagMap),
            statusMap: Object.freeze(statusMap),
            clueTypeMap: Object.freeze(clueTypeMap),
            flowTypeMap: Object.freeze(flowTypeMap),
            list: null,
            total: 0,
            listLoading: false,
            isSuper: store.getters.user.isSuper,
            listQuery: Object.assign({}, initListQuery),
            tableColumns: [
                { prop: 'createdAt', label: '时间', minWidth: 120, formatter: (row, prop) => this.parseTime(row[prop], "{y}-{m}-{d} {h}:{i}") },
                { prop: 'status', label: '状态', width: 100 },
                { prop: 'clueType', label: '线索类型', width: 100, formatter: (row, prop) => this.clueTypeMap.get(row[prop]) },
                { prop: 'sourceName', label: '渠道', width: 100 },
                { prop: 'name', label: '姓名', width: 200 },
                { prop: 'phone', label: '电话', minWidth: 100 },
                { prop: 'id', label: '线索ID', width: 80 },
                { prop: 'dealerName', label: '线索经销商名', width: 200 },
                { prop: 'mappingDealerName', label: '系统经销商名', width: 200, formatter: (row, prop) => row[prop] + row.mappingDealerCode },
                { prop: 'specName', label: '线索车型', width: 100, formatter: (row, prop) => row[prop] !== "" ? row[prop] : row.seriesName },
                { prop: 'mappingSeriesName', label: '系统车系', width: 100 },
                { prop: 'customerSeriesName', label: '客户车系' },
                { prop: 'ownerName', label: '客户经理', width: 120 },
                { prop: 'level', label: '客户级别', width: 120 },
                { prop: 'province', label: '地址', minWidth: 120, formatter: (row, prop) => `${row[prop]}/${row.city}` },
                { prop: 'buyCarAddressText', label: '购车地区', minWidth: 120 },
                { prop: 'flowType', label: '线索流量类型', width: 120, formatter: (row, prop) => this.flowTypeMap.get(row[prop]) || '无' },
                { prop: 'advertiserId', label: '广告主ID', width: 120 },
                { prop: 'advertiserName', label: '广告主名称', width: 120 },
                { prop: 'promotionId', label: '广告项目ID', width: 120 },
                { prop: 'promotionName', label: '广告项目名称', width: 120 },
                { prop: 'isRemote', label: '是否异地购车', width: 120, formatter: (row, prop) => this.formatRemote(row[prop]) },
                { prop: 'isVisitStore', label: '是否到店', width: 120, formatter: (row, prop) => this.formatRemote(row[prop]) },
                { prop: 'isDelivered', label: '是否成交', width: 120, formatter: (row, prop) => this.formatRemote(row[prop]) },
                { prop: 'siteDesc', label: '来源', width: 200 },
                { prop: 'remark', label: '线索备注', width: 200 },
                { prop: 'comments', label: '客户备注', width: 180 },
                { prop: 'clearSeconds', label: '清洗时长', formatter: (row, prop) => `${row[prop]}s` },
                { prop: 'followSeconds', label: '跟进时长', formatter: (row, prop) => `${row[prop]}s` },
                { prop: 'operation', label: '操作', fixed: 'right', width: 150 },
            ],
            roles: store.getters.roles,
            roles_all: [],
            multipleSelection: [],
            dealerCode: [],
            importSources: [],
            offlineSources: [],
            dealerOptions: [],
            seriesOptions: [],
            newDialogVisible: false,
            viewDialogVisible: false,
            viewData: {
                timelines: [],
            },
            assignDealerDialog: false,
            timelineDialog: false,
            importDialogVisible: false,
            isAllCheck: false,
            showBlcTips: false,
            blcInfo: {},
        };
    },
    activated() {
        if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
            this.doReset();
            this.$route.meta.redraw = false;
        }
        if (
            this.$route.meta.hasOwnProperty("refresh") &&
            this.$route.meta.refresh
        ) {
            this.getList();
            this.$route.meta.refresh = false;
        }
    },
    created() {
        this.roles.forEach((item) => {
            this.roles_all.push(item.identify);
        });
        this.doReset();
        this.retrieveSystemData();
        this.getOfflineSources();
        this.retrieveDealerOptions();
        this.retrieveSeriesOptions();
    },
    methods: {
        renderHeader(h, data) {
            return h("span", [
                h("el-checkbox", {
                    on: {
                        change: this.handleAllChange
                    },
                    props: {
                        value: this.isAllCheck,
                    }
                }), h("span", "全选")
            ]);
        },
        handleAllChange(val) {
            this.isAllCheck = val
            this.list = this.list.map(n => {
                n.itemCheck = val;
                return n
            })
            // 点击全选清空之前纪录
            this.multipleSelection = []
        },
        toggleCheck(val) {
            // 记录点击哪些数据
            this.multipleSelection.push(val)
            // 去重
            const index = this.multipleSelection.findIndex( n =>n.id === val.id)
            if( index !== this.multipleSelection.length - 1) {
                this.multipleSelection.splice(index, 1)
            }
        },
        formatRemote(isRemote) {
            if (!isRemote) return "";
            return [CONSTANT_1, CONSTANT_2].includes(isRemote) ? remoteMap.get(isRemote) : "";
        },
        formatterColumnData(row, column) {
            if (typeof column.formatter === 'function') {
                return column.formatter(row, column.prop)
            }
            return row[column.prop]
        },
        doReset() {
            this.list = [];
            this.total = 0;
            this.listLoading = true;
            this.listQuery = Object.assign({}, initListQuery);
            this.doSearch();

        },
        doSearch() {
            this.listQuery.page = 1;
            this.clearCheckGetList()
        },
        clearCheckGetList() {
            this.isAllCheck = false
            this.multipleSelection = []
            this.getList();
        },
        // 导入弹窗
        showImportDialog() {
            this.importDialogVisible = true;
        },
        retrieveSeriesOptions() {
            this.$httpAuth
                .post("/v1/backendVehicleRpc/validSeriesList", {})
                .then((response) => {
                    this.seriesOptions = response.data.records;
                })
                .catch(() => { });
        },
        retrieveSystemData() {
            this.$httpAuth
                .post("/v1/backendDictionaryRpc/getDictionaries", {
                    category: "BYD_IMPORT_SOURCE",
                })
                .then((response) => {
                    this.importSources = response.data.data;
                })
                .catch(() => { });
        },
        getOfflineSources() {
            this.$httpAuth
                .post("/v1/backendDictionaryRpc/getDictionaries", {
                    category: "BYD_OFFLINE_SOURCE",
                })
                .then((response) => {
                    this.offlineSources = response.data.data;
                })
                .catch(() => { });
        },

        getList() {
            this.list = [];
            this.listLoading = true;
            const params = this.getParams();
            this.$httpAuth
                .post("/v1/backendClueRpc/list2", { ...params, isExport: false })
                .then((response) => {
                    this.listLoading = false;
                    let data = response.data.data;
                    data = data.map((item) => {
                        const arr = [item.buyProvince, item.buyCity, item.buyArea];
                        const buyCarAddressText = arr.filter((e) => !!e).join("/");
                        item.buyCarAddressText = buyCarAddressText;
                        return {
                            ...item,
                            buyCarAddressText,
                        };
                    });
                    this.list = data.map(n => {
                        n.itemCheck = this.isAllCheck;
                        return n
                    });
                    this.total = response.data.total;
                })
                .catch(() => {
                    this.listLoading = false;
                });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        retrieveDealerOptions() {
            this.$httpAuth
                .post("/v1/backendDealerRpc/jsonTree", {})
                .then((response) => {
                    this.dealerOptions = response.data.data;
                    this.dealerOptions.unshift({
                        label: "全部",
                        level: 1,
                        value: "",
                    });
                })
                .catch(() => { });
        },
        showAddDialog() {
            this.newDialogVisible = true;
        },
        showSummaryDialog(row) {
            this.viewData = row;
            this.viewDialogVisible = true;
        },
        resendOrders() {
            const selectedData = this.multipleSelection.filter(n => n.itemCheck)
            if (selectedData.length === CONSTANT_0 && !this.isAllCheck) {
                this.$message("请选择重发记录");
                return;
            }
            if (!this.isAllCheck && selectedData.filter(n => n.clueType === CONSTANT_1).length === CONSTANT_0) {
                this.$message("线下线索，不支持重发");
                return;
            }
            const selectedIds = selectedData.map(n => n.id).join(",");
            const noSelectedData = this.multipleSelection.filter(n => !n.itemCheck)
            const noSelectedIds = noSelectedData.map(n => n.id).join(",");
            const params = {
                query: {
                    ...this.getCommonParams()
                },
                isAll: this.isAllCheck,
                ids: this.isAllCheck ? "" : selectedIds,
                excludeIds: this.isAllCheck ? noSelectedIds : ""
            }
            this.$httpAuth
                .post("/v1/backendClueRpc/resend", params)
                .then((response) => {
                    let msg = ''
                    if (response.data.blcError) {
                        const phoneStr = response.data.blcClues.map(o => `【${o}】`)
                        const userStr = response.data.blcError.detail.split(',').map((item) => `【${item}】`)
                        msg = `成功${response.data.success}条，失败${response.data.failed}条；其中${phoneStr}存在于blc名单中，如有疑问请拨打${userStr}`
                    } else {
                        msg = `成功${response.data.success}条${response.data.failed ? `，失败${response.data.failed}条` : ''}${response.data.offline ? `。其中失败的${response.data.offline}条为线下线索，不允许重发` : ''}`
                    }
                    this.$message({
                        message: msg,
                        type: "success",
                    });
                    this.clearCheckGetList();
                })
                .catch(() => {
                    this.saveLoading = false;
                });
        },
        showAssignDealerDialog() {
            const selectedData = this.multipleSelection.filter(n => n.itemCheck)
            if (selectedData.length === CONSTANT_0 && !this.isAllCheck) {
                this.$message("请选择回收记录");
                return;
            }
            if (!this.isAllCheck && selectedData.filter(n => n.clueType === CONSTANT_1).length === CONSTANT_0) {
                this.$message("线下线索，不支持回收");
                return;
            }
            this.assignDealerDialog = true;
        },
        showTimelineDialog(row) {
            this.timelineDialog = true;
            this.viewData = row;
        },
        doExport() {
            const loading = this.$loading({
                lock: true,
                text: "正在导出中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const params = this.getParams()
            this.$httpAuth
                .post("/v1/backendClueRpc/export2", { ...params, isExport: true })
                .then((response) => {
                    setTimeout(() => {
                        loading.close();
                        this.$message({
                            message: "导出任务已产生，请到 平台管理-导出任务 中查看",
                            type: "success",
                        });
                    }, 1000);
                })
                .catch(() => {
                    loading.close();
                });
        },
        getCommonParams() {
            const [dealerSalesCenter, dealerBigArea, dealerProvince, dealerCity, dealerCode] = this.listQuery.dealerCode
            const { isRemote, status, source, clueId, province, city, name, specName, dateType, sourceDesc, ownerName, salesLevel, dealerTypes, dateRange, flowType } = this.listQuery
            const dateStart = dateRange && dateRange.length ? Math.round(dateRange[0].getTime() / 1000) : null;
            const dateEnd = dateRange && dateRange.length ? Math.round(dateRange[1].getTime() / 1000) : null;
            return {
                isRemote,
                status: status.join(","),
                source: source.join(","),
                clueId: clueId || null,
                dealerCode,
                dealerBigArea,
                dealerSalesCenter,
                dealerProvince,
                dealerCity,
                province,
                city,
                name,
                specName,
                dateStart,
                dateEnd,
                dateType,
                sourceDesc,
                ownerName: String(ownerName),
                dealerLevels: salesLevel && salesLevel.length > 0 ? salesLevel.join(",") : "",
                dealerTypes: dealerTypes && dealerTypes.length > 0 ? dealerTypes.join(",") : "",
                flowType: flowType ?? -1,
            }
        },
        getParams() {
            const { page, limit, clueType } = this.listQuery
            return {
                pageStart: (page - 1) * limit,
                pageCount: limit,
                clueType: clueType || null,
                ...this.getCommonParams()
            }
        },
        handleBlc(data) {
            this.showBlcTips = true
            this.blcInfo = data
        }
    },
};
</script>

<style scoped></style>